import { WorkBook, WorkSheet, utils, write } from 'xlsx';
import { saveAs } from 'file-saver';

export const exportToExcel = <T extends Record<string, any>>(data: T[], filename: string, worrkSheetName: string) => {
    const workSheet: WorkSheet = utils.json_to_sheet(data);

    const workBook: WorkBook = utils.book_new();
    utils.book_append_sheet(workBook, workSheet, worrkSheetName);

    const excelBuffer = write(workBook, {
        bookType: "xlsx",
        type:"buffer"
    });

    const dataBlob = new Blob([excelBuffer], {type: "application/vnd.opnxmlformats-officedocument.spreadsheetml.sheet"});
    saveAs(dataBlob, `${filename}.xlsx`);
}